<div class="bg-grey">
  <section class="listing-peace container" role="img" aria-label="iOS and Android self check-in app">
    <div data-aos="fade-up" data-aos-once="true" data-aos-offset="150">
      <div class="row">
        <div class="offset-xl-1 col">
          <h2 class="marketing">Peace of mind. Guaranteed.</h2>
        </div>
      </div>
      <div class="row">
        <div class="offset-xl-1 col-xl-5">
          <p class="subhead-2 text-grey">
            Rent your idle machines with confidence knowing that your equipment will always be returned in the same condition it left.
          </p>
          <a [routerLink]="['/signup']" [queryParams]="{ capability: 'owner' }" [skipLocationChange]="true">Get Started</a>
        </div>
      </div>
    </div>
    <div class="row mt-5">
      <div class="offset-xl-1"></div>

      <div
        class="col-md-4 col-xl-2"
        data-aos="fade-up"
        data-aos-once="true"
        data-aos-offset="100"
        [attr.data-aos-delay]="250 * (i + 1)"
        *ngFor="let marketingCard of marketingCards; index as i"
      >
        <common-marketing-card [marketingCard]="marketingCard"></common-marketing-card>
      </div>
    </div>
  </section>
</div>
